import {FloatingSignUp} from "components/commons";
import CalculatorInfoSection from "../CalculatorInfoSection";
import Calculator from "./Calculator";
import React from "react";

const GoalPlanningSipLumpsumPageContent = () => (
  <>
    <Calculator />
    <FloatingSignUp />
    <CalculatorInfoSection slug="goal-planning-sip-lumpsum" />
  </>
);

export default GoalPlanningSipLumpsumPageContent;
